var WebSocketClosingCode;
(function (WebSocketClosingCode) {
    /**
     * Successful closure.
     */
    WebSocketClosingCode[WebSocketClosingCode["NORMAL_CLOSURE"] = 1000] = "NORMAL_CLOSURE";
    /**
     * The endpoint is going away, such as a server going down or a browser navigating away from the page.
     */
    WebSocketClosingCode[WebSocketClosingCode["GOING_AWAY"] = 1001] = "GOING_AWAY";
    /**
     * An endpoint received a malformed or invalid message.
     */
    WebSocketClosingCode[WebSocketClosingCode["PROTOCOL_ERROR"] = 1002] = "PROTOCOL_ERROR";
    /**
     * The received message contained unsupported data (e.g., binary data when the endpoint only expects text).
     */
    WebSocketClosingCode[WebSocketClosingCode["UNSUPPORTED_DATA"] = 1003] = "UNSUPPORTED_DATA";
    /**
     * No status code was received in the close frame.
     */
    WebSocketClosingCode[WebSocketClosingCode["NO_STATUS_RECEIVED"] = 1005] = "NO_STATUS_RECEIVED";
    /**
     * The connection was closed abnormally without sending or receiving a close frame.
     */
    WebSocketClosingCode[WebSocketClosingCode["ABNORMAL_CLOSURE"] = 1006] = "ABNORMAL_CLOSURE";
    /**
     * The endpoint received a message with an invalid payload data or with a data that violates its policy.
     */
    WebSocketClosingCode[WebSocketClosingCode["INVALID_PAYLOAD_DATA"] = 1007] = "INVALID_PAYLOAD_DATA";
    /**
     * The endpoint detected a policy violation (e.g., a security policy violation).
     */
    WebSocketClosingCode[WebSocketClosingCode["POLICY_VIOLATION"] = 1008] = "POLICY_VIOLATION";
    /**
     * The received message is too big to process.
     */
    WebSocketClosingCode[WebSocketClosingCode["MESSAGE_TOO_BIG"] = 1009] = "MESSAGE_TOO_BIG";
    /**
     * The endpoint expected a WebSocket extension but it is not present or not agreed upon.
     */
    WebSocketClosingCode[WebSocketClosingCode["MISSING_EXTENSION"] = 1010] = "MISSING_EXTENSION";
    /**
     * An internal server error occurred while processing the request.
     */
    WebSocketClosingCode[WebSocketClosingCode["INTERNAL_SERVER_ERROR"] = 1011] = "INTERNAL_SERVER_ERROR";
    /**
     * The service is being restarted.
     */
    WebSocketClosingCode[WebSocketClosingCode["SERVICE_RESTART"] = 1012] = "SERVICE_RESTART";
    /**
     * The endpoint is unable to process the request at the moment; client should retry later.
     */
    WebSocketClosingCode[WebSocketClosingCode["TRY_AGAIN_LATER"] = 1013] = "TRY_AGAIN_LATER";
    /**
     * The TLS handshake failed, and the connection could not be established.
     */
    WebSocketClosingCode[WebSocketClosingCode["TLS_HANDSHAKE_FAILURE"] = 1015] = "TLS_HANDSHAKE_FAILURE";
})(WebSocketClosingCode || (WebSocketClosingCode = {}));
export { WebSocketClosingCode, };
//# sourceMappingURL=web-socket.js.map